import React, { useState } from "react";
import EvaluationForm from "./EvaluationForm";
import EvaluationHistory from "./EvaluationHistory";
import { PackageSearch, History } from "lucide-react";

export default function LandingEvaluations() {
    const [activeTab, setActiveTab] = useState("new"); // "new" | "history"

    return (
        <div className="max-w-6xl mx-auto space-y-6">
            <div className="flex items-center justify-between bg-white p-6 rounded-xl border border-slate-200 shadow-sm">
                <div>
                    <h1 className="text-2xl font-bold text-navy-900 font-serif">Landing Evaluations</h1>
                    <p className="text-slate-500 mt-1">Submit products for import classification and landed cost evaluation.</p>
                </div>
            </div>

            <div className="flex space-x-1 bg-slate-200/50 p-1 rounded-lg w-fit">
                <button
                    onClick={() => setActiveTab("new")}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium transition-colors ${activeTab === "new"
                            ? "bg-white text-navy-900 shadow-sm"
                            : "text-slate-600 hover:text-navy-900 hover:bg-slate-200/50"
                        }`}
                >
                    <PackageSearch size={16} />
                    Create New Evaluation
                </button>
                <button
                    onClick={() => setActiveTab("history")}
                    className={`flex items-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium transition-colors ${activeTab === "history"
                            ? "bg-white text-navy-900 shadow-sm"
                            : "text-slate-600 hover:text-navy-900 hover:bg-slate-200/50"
                        }`}
                >
                    <History size={16} />
                    Evaluation History
                </button>
            </div>

            <div className="mt-6">
                {activeTab === "new" && <EvaluationForm onSuccess={() => setActiveTab("history")} />}
                {activeTab === "history" && <EvaluationHistory />}
            </div>
        </div>
    );
}
